var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('div',{attrs:{"id":"chart-container"}},[_c('fusioncharts',{attrs:{"type":_vm.type,"width":_vm.width,"height":_vm.height,"data-format":_vm.dataFormat,"data-source":_vm.datasource}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }